export default __webpack_public_path__ + "static/media/pic6.1921a2a0.jpg";